const categories = [
  { label: '动作片', icon: 'ri-sword-line', desc: '高燃打斗 热血刺激', color: 'bg-primary-100 text-primary-700', count: '3,200+' },
  { label: '喜剧片', icon: 'ri-emotion-laugh-line', desc: '爆笑不断 欢乐解压', color: 'bg-accent-100 text-accent-700', count: '2,800+' },
  { label: '爱情片', icon: 'ri-heart-line', desc: '甜蜜浪漫 心动时刻', color: 'bg-primary-50 text-primary-600', count: '2,500+' },
  { label: '科幻片', icon: 'ri-rocket-line', desc: '未来视界 想象力MAX', color: 'bg-secondary-100 text-secondary-700', count: '1,900+' },
  { label: '恐怖片', icon: 'ri-ghost-line', desc: '惊悚悬疑 胆大来战', color: 'bg-foreground-100 text-foreground-600', count: '1,600+' },
  { label: '动画片', icon: 'ri-emotion-happy-line', desc: '全家共享 童趣无限', color: 'bg-accent-50 text-accent-600', count: '2,100+' },
  { label: '纪录片', icon: 'ri-earth-line', desc: '真实世界 深度探索', color: 'bg-secondary-50 text-secondary-600', count: '1,200+' },
  { label: '综艺节目', icon: 'ri-tv-line', desc: '热门综艺 轻松陪伴', color: 'bg-primary-50 text-primary-600', count: '3,500+' },
  { label: '电视剧', icon: 'ri-film-line', desc: '全季追剧 一次看够', color: 'bg-accent-100 text-accent-700', count: '4,800+' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          影视分类索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          九大影视分类，精准定位你的观影偏好，找到你想看的内容
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.label}
              href="#index"
              className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 hover:bg-background-100 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${cat.color} flex-shrink-0`}>
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">
                    {cat.label}
                  </h3>
                  <span className="text-[10px] md:text-xs text-foreground-400 whitespace-nowrap">{cat.count}部</span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 hidden sm:block">{cat.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}